// Layout.jsx
import React from 'react';
import '../styles/tokens.css';
import '../styles/Layout.css';

export const Container = ({ children, className = '', ...props }) => (
  <div className={`ds-container ${className}`} {...props}>
    {children}
  </div>
);

export const Section = ({ children, className = '', ...props }) => (
  <section className={`ds-section ${className}`} {...props}>
    {children}
  </section>
);

export const Grid = ({ columns = 1, children, className = '', ...props }) => {
    let gridClass = 'ds-grid';
    if (columns === 2) gridClass += ' ds-grid-2';
    if (columns === 3) gridClass += ' ds-grid-3';
    if (columns === 4) gridClass += ' ds-grid-4';

    return (
        <div className={`${gridClass} ${className}`} {...props}>
            {children}
        </div>
    );
}

export const Flex = ({ direction = 'row', align, justify, gap, children, className = '', ...props }) => {
    const classes = [
        'ds-flex',
        direction === 'column' ? 'ds-flex-col' : '',
        align === 'center' ? 'ds-items-center' : '',
        justify ? `ds-justify-${justify}` : '',
        gap ? `ds-gap-${gap}` : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={classes} {...props}>
            {children}
        </div>
    );
};
